import React from 'react';
import HeaderBar from './general/HeaderBar';
import { useSelector } from 'react-redux';
import EmpresaN from './EmpresaN';
import EmpresaA from './EmpresaA';
import UsuarioA from './UsuarioA';
import UsuarioN from './UsuarioN';

const Home = () => {
  const User = useSelector((state) => state.auth);
  const menu = useSelector((state) => state.menu.menu);


  return (
    <>
      <HeaderBar userName={User.user.Name_User} />
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <h1>Bienvenido a LogistiKa 🚀</h1>
        <p>Gestión eficiente de mantenimiento, calidad, inventario y producción.</p>
      </div>
      {/* Menús para Empresas */}
      {menu === 'empresaNue' ? (
        <EmpresaN />
      ) : menu === 'empresaAct' || menu === 'empresaUpd' ? (
        <EmpresaA />
      ) 
      // Menús para Usuarios
      : menu === 'usuarioAct' || menu === 'usuarioUpd'  ? (
        <UsuarioA />
      ) : menu === 'usuarioNue'? (
        <UsuarioN />
      ) : (
        <h2>
          <div>Hola {User.user.Name_User}</div>
        </h2>
      )}
    </>
  );
};

export default Home;
